import { render, staticRenderFns } from "./ExpandTaskRecursion.vue?vue&type=template&id=d5442072&scoped=true&"
import script from "./ExpandTaskRecursion.vue?vue&type=script&lang=js&"
export * from "./ExpandTaskRecursion.vue?vue&type=script&lang=js&"
import style0 from "./ExpandTaskRecursion.vue?vue&type=style&index=0&id=d5442072&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5442072",
  null
  
)

export default component.exports